import React from 'react';
import PropTypes from 'prop-types';

function UnionPayCardIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke="#E1E1E1" rx="3" />
        <path
          fill="#E03A3E"
          d="M1 2.991C1 1.891 1.89 1 3.002 1h27.996C32.104 1 33 1.89 33 2.991V21.01c0 1.1-.89 1.991-2.002 1.991H3.002A1.995 1.995 0 011 21.009V2.99z"
        />
        <path
          fill="#004B85"
          d="M12.728 2.991C12.878 1.891 13.89 1 15 1h13c1.105 0 1.96.89 1.91 1.991l-.82 18.018A2.105 2.105 0 0127.004 23H11.997c-1.103 0-1.876-.89-1.725-1.991L12.728 2.99z"
        />
        <path
          fill="#018287"
          d="M23.728 2.991c.15-1.1 1.168-1.991 2.27-1.991h5.005C32.106 1 33 1.89 33 2.991V21.01c0 1.1-.902 1.991-2.009 1.991H23.01c-1.11 0-1.888-.89-1.737-1.991L23.728 2.99z"
        />
      </g>
    </svg>
  );
}

UnionPayCardIcon.propTypes = {
  className: PropTypes.string,
};

export default UnionPayCardIcon;
